import type { Middleware, Placement } from '@floating-ui/react';

const ARROW_PADDING = 8;

export const autoSafeFlip: Middleware = {
    name: 'autoSafeFlip',
    fn: (state) => {
        const { x, y, placement, rects } = state;

        const isHorizontal = placement.startsWith('left') || placement.startsWith('right');

        if (isHorizontal) {
            const refCenterY = rects.reference.y + rects.reference.height / 2;
            const floatingTop = y;

            const arrowY = refCenterY - floatingTop;
            const minArrowY = ARROW_PADDING;
            const maxArrowY = rects.floating.height - ARROW_PADDING;

            if (arrowY < minArrowY || arrowY > maxArrowY) {
                const availableTop = rects.reference.y;
                const viewportHeight = typeof window !== 'undefined' ? window.innerHeight : 800;
                const availableBottom = viewportHeight - (rects.reference.y + rects.reference.height);

                const newPlacement: Placement = availableBottom >= availableTop ? 'bottom' : 'top';

                const newY = newPlacement === 'bottom'
                    ? rects.reference.y + rects.reference.height + 10
                    : rects.reference.y - rects.floating.height - 10;

                const newX = rects.reference.x + rects.reference.width / 2 - rects.floating.width / 2;

                return {
                    x: newX,
                    y: newY,
                    data: {},
                    reset: {
                        placement: newPlacement,
                    },
                };
            }
        } else {
            const refCenterX = rects.reference.x + rects.reference.width / 2;
            const floatingLeft = x;

            const arrowX = refCenterX - floatingLeft;
            const minArrowX = ARROW_PADDING;
            const maxArrowX = rects.floating.width - ARROW_PADDING;

            if (arrowX < minArrowX || arrowX > maxArrowX) {
                const availableLeft = rects.reference.x;
                const viewportWidth = typeof window !== 'undefined' ? window.innerWidth : 800;
                const availableRight = viewportWidth - (rects.reference.x + rects.reference.width);

                const newPlacement: Placement = availableRight >= availableLeft ? 'right' : 'left';

                const newX = newPlacement === 'right'
                    ? rects.reference.x + rects.reference.width + 10
                    : rects.reference.x - rects.floating.width - 10;

                const newY = rects.reference.y + rects.reference.height / 2 - rects.floating.height / 2;

                return {
                    x: newX,
                    y: newY,
                    data: {},
                    reset: {
                        placement: newPlacement,
                    },
                };
            }
        }

        return {};
    },
};

export { ARROW_PADDING };
